const countries = [
  {
    isoCode2: 'AF',
    name: 'Afghanistan',
  },
  {
    isoCode2: 'AX',
    name: 'Aland Islands',
  },
  {
    isoCode2: 'AL',
    name: 'Albania',
  },
  {
    isoCode2: 'DZ',
    name: 'Algeria',
  },
  {
    isoCode2: 'AS',
    name: 'American Samoa',
  },
  {
    isoCode2: 'AD',
    name: 'Andorra',
  },
  {
    isoCode2: 'AO',
    name: 'Angola',
  },
  {
    isoCode2: 'AI',
    name: 'Anguilla',
  },
  {
    isoCode2: 'AQ',
    name: 'Antarctica',
  },
  {
    isoCode2: 'AG',
    name: 'Antigua and Barbuda',
  },
  {
    isoCode2: 'AR',
    name: 'Argentina',
  },
  {
    isoCode2: 'AM',
    name: 'Armenia',
  },
  {
    isoCode2: 'AW',
    name: 'Aruba',
  },
  {
    isoCode2: 'AU',
    name: 'Australia',
  },
  {
    isoCode2: 'AT',
    name: 'Austria',
  },
  {
    isoCode2: 'AZ',
    name: 'Azerbaijan',
  },
  {
    isoCode2: 'BS',
    name: 'Bahamas',
  },
  {
    isoCode2: 'BH',
    name: 'Bahrain',
  },
  {
    isoCode2: 'BD',
    name: 'Bangladesh',
  },
  {
    isoCode2: 'BB',
    name: 'Barbados',
  },
  {
    isoCode2: 'BY',
    name: 'Belarus',
  },
  {
    isoCode2: 'BE',
    name: 'Belgium',
  },
  {
    isoCode2: 'BZ',
    name: 'Belize',
  },
  {
    isoCode2: 'BJ',
    name: 'Benin',
  },
  {
    isoCode2: 'BM',
    name: 'Bermuda',
  },
  {
    isoCode2: 'BT',
    name: 'Bhutan',
  },
  {
    isoCode2: 'BO',
    name: 'Bolivia',
  },
  {
    isoCode2: 'BQ',
    name: 'Bonaire, Sint Eustatius And Saba',
  },
  {
    isoCode2: 'BA',
    name: 'Bosnia and Herzegovina',
  },
  {
    isoCode2: 'BW',
    name: 'Botswana',
  },
  {
    isoCode2: 'BV',
    name: 'Bouvet Island',
  },
  {
    isoCode2: 'BR',
    name: 'Brazil',
  },
  {
    isoCode2: 'IO',
    name: 'British Indian Ocean Territory',
  },
  {
    isoCode2: 'BN',
    name: 'Brunei Darussalam',
  },
  {
    isoCode2: 'BG',
    name: 'Bulgaria',
  },
  {
    isoCode2: 'BF',
    name: 'Burkina Faso',
  },
  {
    isoCode2: 'BI',
    name: 'Burundi',
  },
  {
    isoCode2: 'KH',
    name: 'Cambodia',
  },
  {
    isoCode2: 'CM',
    name: 'Cameroon',
  },
  {
    isoCode2: 'CA',
    name: 'Canada',
  },
  {
    isoCode2: 'CV',
    name: 'Cape Verde',
  },
  {
    isoCode2: 'KY',
    name: 'Cayman Islands',
  },
  {
    isoCode2: 'CF',
    name: 'Central African Republic',
  },
  {
    isoCode2: 'TD',
    name: 'Chad',
  },
  {
    isoCode2: 'CL',
    name: 'Chile',
  },
  {
    isoCode2: 'CN',
    name: 'China',
  },
  {
    isoCode2: 'CX',
    name: 'Christmas Island',
  },
  {
    isoCode2: 'CC',
    name: 'Cocos (Keeling) Islands',
  },
  {
    isoCode2: 'CO',
    name: 'Colombia',
  },
  {
    isoCode2: 'KM',
    name: 'Comoros',
  },
  {
    isoCode2: 'CG',
    name: 'Congo',
  },
  {
    isoCode2: 'CK',
    name: 'Cook Islands',
  },
  {
    isoCode2: 'CR',
    name: 'Costa Rica',
  },
  {
    isoCode2: 'CI',
    name: 'Cote d`Ivoire',
  },
  {
    isoCode2: 'HR',
    name: 'Croatia',
  },
  {
    isoCode2: 'CU',
    name: 'Cuba',
  },
  {
    isoCode2: 'CW',
    name: 'Curacao',
  },
  {
    isoCode2: 'CY',
    name: 'Cyprus',
  },
  {
    isoCode2: 'CZ',
    name: 'Czech Republic',
  },
  {
    isoCode2: 'KP',
    name: 'Democratic People`s Republic of Korea',
  },
  {
    isoCode2: 'CD',
    name: 'Democratic Republic of the Congo',
  },
  {
    isoCode2: 'DK',
    name: 'Denmark',
  },
  {
    isoCode2: 'DJ',
    name: 'Djibouti',
  },
  {
    isoCode2: 'DM',
    name: 'Dominica',
  },
  {
    isoCode2: 'DO',
    name: 'Dominican Republic',
  },
  {
    isoCode2: 'EC',
    name: 'Ecuador',
  },
  {
    isoCode2: 'EG',
    name: 'Egypt',
  },
  {
    isoCode2: 'SV',
    name: 'El Salvador',
  },
  {
    isoCode2: 'GQ',
    name: 'Equatorial Guinea',
  },
  {
    isoCode2: 'ER',
    name: 'Eritrea',
  },
  {
    isoCode2: 'EE',
    name: 'Estonia',
  },
  {
    isoCode2: 'ET',
    name: 'Ethiopia',
  },
  {
    isoCode2: 'FK',
    name: 'Falkland Islands (Malvinas)',
  },
  {
    isoCode2: 'FO',
    name: 'Faroe Islands',
  },
  {
    isoCode2: 'FJ',
    name: 'Fiji',
  },
  {
    isoCode2: 'FI',
    name: 'Finland',
  },
  {
    isoCode2: 'FR',
    name: 'France',
  },
  {
    isoCode2: 'GF',
    name: 'French Guiana',
  },
  {
    isoCode2: 'PF',
    name: 'French Polynesia',
  },
  {
    isoCode2: 'TF',
    name: 'French Southern Territories',
  },
  {
    isoCode2: 'GA',
    name: 'Gabon',
  },
  {
    isoCode2: 'GM',
    name: 'Gambia',
  },
  {
    isoCode2: 'GE',
    name: 'Georgia',
  },
  {
    isoCode2: 'DE',
    name: 'Germany',
  },
  {
    isoCode2: 'GH',
    name: 'Ghana',
  },
  {
    isoCode2: 'GI',
    name: 'Gibraltar',
  },
  {
    isoCode2: 'GR',
    name: 'Greece',
  },
  {
    isoCode2: 'GL',
    name: 'Greenland',
  },
  {
    isoCode2: 'GD',
    name: 'Grenada',
  },
  {
    isoCode2: 'GP',
    name: 'Guadeloupe',
  },
  {
    isoCode2: 'GU',
    name: 'Guam',
  },
  {
    isoCode2: 'GT',
    name: 'Guatemala',
  },
  {
    isoCode2: 'GG',
    name: 'Guernsey',
  },
  {
    isoCode2: 'GN',
    name: 'Guinea',
  },
  {
    isoCode2: 'GW',
    name: 'Guinea-Bissau',
  },
  {
    isoCode2: 'GY',
    name: 'Guyana',
  },
  {
    isoCode2: 'HT',
    name: 'Haiti',
  },
  {
    isoCode2: 'HM',
    name: 'Heard Island and McDonald Islands',
  },
  {
    isoCode2: 'VA',
    name: 'Holy See (Vatican City State)',
  },
  {
    isoCode2: 'HN',
    name: 'Honduras',
  },
  {
    isoCode2: 'HK',
    name: 'Hong Kong (Special Administrative Region of China)',
  },
  {
    isoCode2: 'HU',
    name: 'Hungary',
  },
  {
    isoCode2: 'IS',
    name: 'Iceland',
  },
  {
    isoCode2: 'IN',
    name: 'India',
  },
  {
    isoCode2: 'ID',
    name: 'Indonesia',
  },
  {
    isoCode2: 'IR',
    name: 'Iran (Islamic Republic of)',
  },
  {
    isoCode2: 'IQ',
    name: 'Iraq',
  },
  {
    isoCode2: 'IE',
    name: 'Ireland',
  },
  {
    isoCode2: 'IM',
    name: 'Isle Of Man',
  },
  {
    isoCode2: 'IL',
    name: 'Israel',
  },
  {
    isoCode2: 'IT',
    name: 'Italy',
  },
  {
    isoCode2: 'JM',
    name: 'Jamaica',
  },
  {
    isoCode2: 'JP',
    name: 'Japan',
  },
  {
    isoCode2: 'JE',
    name: 'Jersey',
  },
  {
    isoCode2: 'JO',
    name: 'Jordan',
  },
  {
    isoCode2: 'KZ',
    name: 'Kazakhstan',
  },
  {
    isoCode2: 'KE',
    name: 'Kenya',
  },
  {
    isoCode2: 'KI',
    name: 'Kiribati',
  },
  {
    isoCode2: 'XK',
    name: 'Kosovo',
  },
  {
    isoCode2: 'KW',
    name: 'Kuwait',
  },
  {
    isoCode2: 'KG',
    name: 'Kyrgyzstan',
  },
  {
    isoCode2: 'LA',
    name: 'Lao People`s Democratic Republic',
  },
  {
    isoCode2: 'LV',
    name: 'Latvia',
  },
  {
    isoCode2: 'LB',
    name: 'Lebanon',
  },
  {
    isoCode2: 'LS',
    name: 'Lesotho',
  },
  {
    isoCode2: 'LR',
    name: 'Liberia',
  },
  {
    isoCode2: 'LY',
    name: 'Libyan Arab Jamahiriya',
  },
  {
    isoCode2: 'LI',
    name: 'Liechtenstein',
  },
  {
    isoCode2: 'LT',
    name: 'Lithuania',
  },
  {
    isoCode2: 'LU',
    name: 'Luxembourg',
  },
  {
    isoCode2: 'MO',
    name: 'Macau (Special Administrative Region of China)',
  },
  {
    isoCode2: 'MG',
    name: 'Madagascar',
  },
  {
    isoCode2: 'MW',
    name: 'Malawi',
  },
  {
    isoCode2: 'MY',
    name: 'Malaysia',
  },
  {
    isoCode2: 'MV',
    name: 'Maldives',
  },
  {
    isoCode2: 'ML',
    name: 'Mali',
  },
  {
    isoCode2: 'MT',
    name: 'Malta',
  },
  {
    isoCode2: 'MH',
    name: 'Marshall Islands',
  },
  {
    isoCode2: 'MQ',
    name: 'Martinique',
  },
  {
    isoCode2: 'MR',
    name: 'Mauritania',
  },
  {
    isoCode2: 'MU',
    name: 'Mauritius',
  },
  {
    isoCode2: 'YT',
    name: 'Mayotte',
  },
  {
    isoCode2: 'MX',
    name: 'Mexico',
  },
  {
    isoCode2: 'FM',
    name: 'Micronesia (Federated States of)',
  },
  {
    isoCode2: 'MD',
    name: 'Moldova (Republic of)',
  },
  {
    isoCode2: 'MC',
    name: 'Monaco',
  },
  {
    isoCode2: 'MN',
    name: 'Mongolia',
  },
  {
    isoCode2: 'ME',
    name: 'Montenegro',
  },
  {
    isoCode2: 'MS',
    name: 'Montserrat',
  },
  {
    isoCode2: 'MA',
    name: 'Morocco',
  },
  {
    isoCode2: 'MZ',
    name: 'Mozambique',
  },
  {
    isoCode2: 'MM',
    name: 'Myanmar',
  },
  {
    isoCode2: 'NA',
    name: 'Namibia',
  },
  {
    isoCode2: 'NR',
    name: 'Nauru',
  },
  {
    isoCode2: 'NP',
    name: 'Nepal',
  },
  {
    isoCode2: 'NL',
    name: 'Netherlands',
  },
  {
    isoCode2: 'AN',
    name: 'Netherlands Antilles',
  },
  {
    isoCode2: 'NC',
    name: 'New Caledonia',
  },
  {
    isoCode2: 'NZ',
    name: 'New Zealand',
  },
  {
    isoCode2: 'NI',
    name: 'Nicaragua',
  },
  {
    isoCode2: 'NE',
    name: 'Niger',
  },
  {
    isoCode2: 'NG',
    name: 'Nigeria',
  },
  {
    isoCode2: 'NU',
    name: 'Niue',
  },
  {
    isoCode2: 'NF',
    name: 'Norfolk Island',
  },
  {
    isoCode2: 'MK',
    name: 'North Macedonia (Republic of North Macedonia)',
  },
  {
    isoCode2: 'MP',
    name: 'Northern Mariana Islands',
  },
  {
    isoCode2: 'NO',
    name: 'Norway',
  },
  {
    isoCode2: 'OM',
    name: 'Oman',
  },
  {
    isoCode2: 'PK',
    name: 'Pakistan',
  },
  {
    isoCode2: 'PW',
    name: 'Palau',
  },
  {
    isoCode2: 'PS',
    name: 'Palestinian Territory (Occupied)',
  },
  {
    isoCode2: 'PA',
    name: 'Panama',
  },
  {
    isoCode2: 'PG',
    name: 'Papua New Guinea',
  },
  {
    isoCode2: 'PY',
    name: 'Paraguay',
  },
  {
    isoCode2: 'PE',
    name: 'Peru',
  },
  {
    isoCode2: 'PH',
    name: 'Philippines',
  },
  {
    isoCode2: 'PN',
    name: 'Pitcairn',
  },
  {
    isoCode2: 'PL',
    name: 'Poland',
  },
  {
    isoCode2: 'PT',
    name: 'Portugal',
  },
  {
    isoCode2: 'PR',
    name: 'Puerto Rico',
  },
  {
    isoCode2: 'QA',
    name: 'Qatar',
  },
  {
    isoCode2: 'KR',
    name: 'Republic of Korea',
  },
  {
    isoCode2: 'RE',
    name: 'Reunion',
  },
  {
    isoCode2: 'RO',
    name: 'Romania',
  },
  {
    isoCode2: 'RU',
    name: 'Russian Federation',
  },
  {
    isoCode2: 'RW',
    name: 'Rwanda',
  },
  {
    isoCode2: 'BL',
    name: 'Saint Barthelemy',
  },
  {
    isoCode2: 'SH',
    name: 'Saint Helena',
  },
  {
    isoCode2: 'KN',
    name: 'Saint Kitts and Nevis',
  },
  {
    isoCode2: 'LC',
    name: 'Saint Lucia',
  },
  {
    isoCode2: 'MF',
    name: 'Saint Martin French',
  },
  {
    isoCode2: 'PM',
    name: 'Saint Pierre and Miquelon',
  },
  {
    isoCode2: 'VC',
    name: 'Saint Vincent and the Grenadines',
  },
  {
    isoCode2: 'WS',
    name: 'Samoa',
  },
  {
    isoCode2: 'SM',
    name: 'San Marino',
  },
  {
    isoCode2: 'ST',
    name: 'Sao Tome and Principe',
  },
  {
    isoCode2: 'SA',
    name: 'Saudi Arabia',
  },
  {
    isoCode2: 'SN',
    name: 'Senegal',
  },
  {
    isoCode2: 'RS',
    name: 'Serbia',
  },
  {
    isoCode2: 'SC',
    name: 'Seychelles',
  },
  {
    isoCode2: 'SL',
    name: 'Sierra Leone',
  },
  {
    isoCode2: 'SG',
    name: 'Singapore',
  },
  {
    isoCode2: 'SX',
    name: 'Sint Maarten Dutch',
  },
  {
    isoCode2: 'SK',
    name: 'Slovakia',
  },
  {
    isoCode2: 'SI',
    name: 'Slovenia',
  },
  {
    isoCode2: 'SB',
    name: 'Solomon Islands',
  },
  {
    isoCode2: 'SO',
    name: 'Somalia',
  },
  {
    isoCode2: 'ZA',
    name: 'South Africa',
  },
  {
    isoCode2: 'GS',
    name: 'South Georgia and The South Sandwich Islands',
  },
  {
    isoCode2: 'SS',
    name: 'South Sudan',
  },
  {
    isoCode2: 'ES',
    name: 'Spain',
  },
  {
    isoCode2: 'LK',
    name: 'Sri Lanka',
  },
  {
    isoCode2: 'SD',
    name: 'Sudan',
  },
  {
    isoCode2: 'SR',
    name: 'Suriname',
  },
  {
    isoCode2: 'SJ',
    name: 'Svalbard and Jan Mayen Islands',
  },
  {
    isoCode2: 'SZ',
    name: 'Swaziland',
  },
  {
    isoCode2: 'SE',
    name: 'Sweden',
  },
  {
    isoCode2: 'CH',
    name: 'Switzerland',
  },
  {
    isoCode2: 'SY',
    name: 'Syrian Arab Republic',
  },
  {
    isoCode2: 'TW',
    name: 'Taiwan (Province of China)',
  },
  {
    isoCode2: 'TJ',
    name: 'Tajikistan',
  },
  {
    isoCode2: 'TZ',
    name: 'Tanzania (United Republic of)',
  },
  {
    isoCode2: 'TH',
    name: 'Thailand',
  },
  {
    isoCode2: 'TL',
    name: 'Timor-Leste (East Timor)',
  },
  {
    isoCode2: 'TG',
    name: 'Togo',
  },
  {
    isoCode2: 'TK',
    name: 'Tokelau',
  },
  {
    isoCode2: 'TO',
    name: 'Tonga',
  },
  {
    isoCode2: 'TT',
    name: 'Trinidad and Tobago',
  },
  {
    isoCode2: 'TN',
    name: 'Tunisia',
  },
  {
    isoCode2: 'TR',
    name: 'Turkey',
  },
  {
    isoCode2: 'TM',
    name: 'Turkmenistan',
  },
  {
    isoCode2: 'TC',
    name: 'Turks and Caicos Islands',
  },
  {
    isoCode2: 'TV',
    name: 'Tuvalu',
  },
  {
    isoCode2: 'UG',
    name: 'Uganda',
  },
  {
    isoCode2: 'UA',
    name: 'Ukraine',
  },
  {
    isoCode2: 'AE',
    name: 'United Arab Emirates',
  },
  {
    isoCode2: 'GB',
    name: 'United Kingdom',
  },
  {
    isoCode2: 'US',
    name: 'United States',
  },
  {
    isoCode2: 'UM',
    name: 'United States Minor Outlying Islands',
  },
  {
    isoCode2: 'UY',
    name: 'Uruguay',
  },
  {
    isoCode2: 'UZ',
    name: 'Uzbekistan',
  },
  {
    isoCode2: 'VU',
    name: 'Vanuatu',
  },
  {
    isoCode2: 'VE',
    name: 'Venezuela',
  },
  {
    isoCode2: 'VN',
    name: 'Vietnam',
  },
  {
    isoCode2: 'VG',
    name: 'Virgin Islands British',
  },
  {
    isoCode2: 'VI',
    name: 'Virgin Islands US',
  },
  {
    isoCode2: 'WF',
    name: 'Wallis and Futuna Islands',
  },
  {
    isoCode2: 'EH',
    name: 'Western Sahara',
  },
  {
    isoCode2: 'YE',
    name: 'Yemen',
  },
  {
    isoCode2: 'YU',
    name: 'Yugoslavia',
  },
  {
    isoCode2: 'ZM',
    name: 'Zambia',
  },
  {
    isoCode2: 'ZW',
    name: 'Zimbabwe',
  },
];

export default countries;
